import React from "react";
import get from "lodash/get";
import moment from "moment";
import { connect } from "react-redux";
import {
  Layout,
  Table,
  Switch,
  Button,
  Modal,
  message,
  Tooltip,
  Icon,
  Input,
} from "antd";


import Footer from "../../components/Footer/Footer";
import NewsletterForm from "../../components/NewsletterForm/NewsletterForm";
import classes from "./Newsletter.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getNewsletterRequest,
  deleteNewsletterRequest,
  activateNewsletterRequest,
  getSettingsRolesRequest,
  getSitesRequest,
  sendNewsletterRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getNewsletterCreatePermission,
  getNewsletterUpdatePermission,
  getNewsletterDeletePermission,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;
const { Search } = Input;

class Newsletter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newsletters: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      newsletterEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      approvedSelected: null,
      sendingId: null,
      roles: [],
    };
  }

  async componentDidMount() {
    await this.onNameSearch();

    try {
      const { data } = await getSettingsRolesRequest();
      const { data: sites } = await getSitesRequest();
      this.setState({ roles: data, sites });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1
      },
      this.getNewsletter
    );
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getNewsletter);
  };

  getNewsletter = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getNewsletterRequest({
        search: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });

      this.setState({
        newsletters: data.data,
        total: data.total_pages * per_page,
        currentPage: page,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        newsletters: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getNewsletter(pagination.current, pagination.pageSize)
    );
  };

  onNewsletterEdit = (newsletter) => () => {
    this.setState({ newsletterEdit: newsletter });
  };

  onNewsletterEditHide = () => {
    this.setState({ newsletterEdit: null });
  };

  onNewsletterEditSubmit = () => {
    this.setState({ newsletterEdit: null }, this.getNewsletter);
  };

  addNewsletter = () => {
    this.setState({ newsletterEdit: {} });
  };

  onSwitchNewsletterActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteNewsletterRequest(id);
      } else {
        await activateNewsletterRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getNewsletter();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
    }
  };

  onSend = async (id) => {
    this.setState({
      sendingId: id,
    });

    try {
      await sendNewsletterRequest(id);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", "Error"));
    }

    this.setState({
      sendingId: null,
    });

    this.getNewsletter();
  };

  render() {
    const {
      isLoading,
      sites,
      newsletters,
      currentPage,
      total,
      pageSize,
      newsletterEdit,
      roles,
      nameSearch,
    } = this.state;
    const {
      newsletterCreatePermission,
      newsletterUpdatePermission,
      newsletterDeletePermission,
    } = this.props;

    const columns = [
      {
        dataIndex: "subject",
        key: "subject",
        title: this.props.i18n.t('Subject'),
      },
      {
        dataIndex: "is_scheduled",
        key: "is_scheduled",
        title: this.props.i18n.t('NamespaceNewsletter:Is scheduled'),
        render: (val) => (val ? this.props.i18n.t('Yes') : this.props.i18n.t('No')),
      },
      {
        dataIndex: "sent_at",
        key: "sent_at",
        title: this.props.i18n.t('NamespaceNewsletter:Sent at'),
        render: (val, row) =>
          val
            ? moment(val).format("YYYY MM DD, HH:mm") + ` ${row.time_zone}`
            : "",
      },
      {
        dataIndex: "send_at",
        key: "send_at",
        title: this.props.i18n.t('NamespaceNewsletter:Date scheduled'),
        render: (val, row) =>
          val
            ? moment(val).format("YYYY MM DD, HH:mm") + ` ${row.time_zone}`
            : "",
      },
      {
        dataIndex: "repeat",
        key: "repeat",
        title: this.props.i18n.t('NamespaceNewsletter:Recurrence options'),
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t('Actions'),
        render: (val, newsletter) => (
          <div className={classes.actions}>
            <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceNewsletter:Edit newsletter')}>
              <Icon
                type="edit"
                theme="filled"
                className={classes.iconEdit}
                onClick={this.onNewsletterEdit(newsletter)}
              />
            </Tooltip>
            &nbsp; &nbsp;
            <div style={{ width: "90px", display: "flex" }}>
              {((newsletterUpdatePermission &&
                newsletter.state === "inactive") ||
                (newsletterDeletePermission &&
                  newsletter.state === "active")) && (
                <div>
                  <b className={classes.switchLabel}>{this.props.i18n.t('State')}</b>
                  <br />
                  <Tooltip placement="topLeft" title={this.props.i18n.t('Activate / Deactivate')}>
                    <Switch
                      className={classes.reactivateBtn}
                      checked={newsletter.state === "active"}
                      onChange={this.onSwitchNewsletterActivation(
                        val,
                        newsletter.state
                      )}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t('NamespaceNewsletter:Mailing List')}</h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                <Search
                  placeholder={this.props.i18n.t('By name')}
                  enterButton={this.props.i18n.t('Search')}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t('Clear')}
              </span>
            </div>

            {newsletterCreatePermission && (
              <div>
                <Button type="primary" onClick={this.addNewsletter}>
                  {this.props.i18n.t('NamespaceNewsletter:Add newsletter')}
                </Button>
                <br />
                <br />
              </div>
            )}

            <Table
              columns={columns}
              dataSource={newsletters}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: 'both',
              }}
            />

            <Modal
              visible={!!newsletterEdit}
              onCancel={this.onNewsletterEditHide}
              footer={null}
              width="90%"
            >
              {newsletterEdit && (
                <NewsletterForm
                  roles={roles}
                  sites={sites}
                  {...newsletterEdit}
                  isNew={newsletterEdit && !newsletterEdit.id}
                  onSubmit={this.onNewsletterEditSubmit}
                  onCancel={this.onNewsletterEditHide}
                />
              )}
            </Modal>
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  newsletterCreatePermission: getNewsletterCreatePermission(state),
  newsletterUpdatePermission: getNewsletterUpdatePermission(state),
  newsletterDeletePermission: getNewsletterDeletePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Newsletter))
);



// WEBPACK FOOTER //
// ./src/containers/Newsletter/Newsletter.js